var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePodcasts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.352941 0 0 0 0 0.400000 0 0 0 0 0.541176 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-255 -6)",
    filter: "url(#a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(255 6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAB908",
    d: "M7.72 11.91h2.205V5.558H7.719v3.705z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#0066D9",
    cx: 1.103,
    cy: 8.138,
    rx: 1.103,
    ry: 1.092
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#0066D9",
    cx: 1.103,
    cy: 9.329,
    rx: 1.103,
    ry: 1.092
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066D9",
    d: "M0 8.138h2.205v1.191H0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4285F4",
    cx: 16.541,
    cy: 9.329,
    rx: 1.103,
    ry: 1.092
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4285F4",
    cx: 16.541,
    cy: 8.138,
    rx: 1.103,
    ry: 1.092
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M17.644 9.33H15.44V8.139h2.205z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EA4335",
    cx: 4.912,
    cy: 11.711,
    rx: 1.103,
    ry: 1.092
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EA4335",
    cx: 4.912,
    cy: 12.902,
    rx: 1.103,
    ry: 1.092
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M3.809 11.711h2.205v1.191H3.809z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EA4335",
    cx: 4.912,
    cy: 4.565,
    rx: 1.103,
    ry: 1.092
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EA4335",
    cx: 4.912,
    cy: 8.436,
    rx: 1.103,
    ry: 1.092
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M3.809 4.565h2.205v3.896H3.809z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#34A853",
    cx: 12.732,
    cy: 5.756,
    rx: 1.103,
    ry: 1.092
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#34A853",
    cx: 12.732,
    cy: 4.565,
    rx: 1.103,
    ry: 1.092
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M13.834 5.757H11.63V4.566h2.205z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FAB908",
    cx: 8.822,
    cy: 2.283,
    rx: 1.103,
    ry: 1.092
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FAB908",
    cx: 8.822,
    cy: 1.092,
    rx: 1.103,
    ry: 1.092
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB908",
    d: "M9.925 2.282H7.72v-1.19h2.205z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FAB908",
    cx: 8.822,
    cy: 16.376,
    rx: 1.103,
    ry: 1.092
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FAB908",
    cx: 8.822,
    cy: 15.185,
    rx: 1.103,
    ry: 1.092
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB908",
    d: "M9.925 16.376H7.72v-1.19h2.205z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#34A853",
    cx: 12.732,
    cy: 12.902,
    rx: 1.103,
    ry: 1.092
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#34A853",
    cx: 12.732,
    cy: 9.032,
    rx: 1.103,
    ry: 1.092
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M13.834 12.902H11.63v-3.87h2.205z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FAB908",
    cx: 8.822,
    cy: 5.558,
    rx: 1.103,
    ry: 1.092
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FAB908",
    cx: 8.822,
    cy: 11.91,
    rx: 1.103,
    ry: 1.092
  })), /*#__PURE__*/React.createElement("path", {
    d: "M325.95 18.802h-1.349V8.95h3.578c.89 0 1.659.278 2.309.833.65.555.975 1.254.975 2.098 0 .844-.325 1.544-.975 2.099-.65.555-1.42.833-2.31.833h-2.228v3.99zm0-5.201h2.258c.567 0 1.021-.18 1.364-.537.342-.358.513-.752.513-1.184 0-.43-.171-.825-.513-1.183-.343-.358-.797-.537-1.364-.537h-2.258v3.44zm6.631-.73c.694-.688 1.579-1.032 2.654-1.032s1.96.342 2.654 1.025c.694.684 1.04 1.54 1.04 2.567 0 1.027-.346 1.883-1.04 2.566-.694.684-1.579 1.025-2.654 1.025s-1.96-.341-2.654-1.025c-.694-.683-1.04-1.539-1.04-2.566 0-1.028.346-1.88 1.04-2.56zm.997 4.335c.47.44 1.022.66 1.657.66s1.185-.222 1.65-.667c.464-.445.696-1.034.696-1.768s-.232-1.324-.697-1.769a2.304 2.304 0 00-1.649-.667c-.635 0-1.185.223-1.65.667-.464.445-.696 1.035-.696 1.769s.23 1.325.69 1.775zm9.417 1.816c-.929 0-1.73-.344-2.404-1.032-.675-.688-1.012-1.54-1.012-2.56 0-1.018.337-1.87 1.012-2.559.674-.688 1.475-1.032 2.404-1.032.547 0 1.039.11 1.473.33.435.22.76.496.975.826h.06l-.06-.936V8.95h1.35v9.853h-1.29v-.936h-.06c-.215.33-.54.606-.975.826-.434.22-.926.33-1.473.33zm.22-1.156c.635 0 1.175-.22 1.62-.66.445-.44.667-1.032.667-1.775 0-.743-.222-1.335-.667-1.775a2.217 2.217 0 00-1.62-.66c-.626 0-1.163.222-1.613.666-.45.445-.674 1.035-.674 1.769s.225 1.323.674 1.768c.45.445.987.667 1.613.667zm8.258 1.156c-1.075 0-1.96-.341-2.653-1.025-.694-.683-1.041-1.539-1.041-2.566 0-1.028.347-1.883 1.04-2.567.695-.683 1.58-1.025 2.654-1.025.802 0 1.467.184 1.994.55.528.368.914.83 1.159 1.39l-1.232.482c-.371-.844-1.04-1.266-2.009-1.266-.596 0-1.121.23-1.576.688-.454.459-.681 1.041-.681 1.748 0 .706.227 1.289.681 1.747.455.46.98.688 1.576.688 1.007 0 1.701-.422 2.082-1.266l1.203.482c-.245.55-.638 1.012-1.18 1.383-.543.372-1.215.557-2.017.557zm6.397 0c-.762 0-1.4-.206-1.913-.619-.514-.413-.77-.959-.77-1.637 0-.734.303-1.31.909-1.727.606-.418 1.354-.627 2.243-.627.792 0 1.442.138 1.95.413v-.192c0-.496-.18-.893-.542-1.19-.362-.299-.807-.448-1.335-.448-.39 0-.745.087-1.063.262-.317.174-.535.412-.652.715l-1.232-.495c.167-.404.494-.778.983-1.122.488-.344 1.134-.516 1.935-.516.919 0 1.681.252 2.287.757.606.505.91 1.216.91 2.133v4.073h-1.29v-.936h-.06c-.537.771-1.324 1.156-2.36 1.156zm.22-1.156c.557 0 1.063-.194 1.517-.584.455-.39.682-.851.682-1.383-.381-.294-.953-.44-1.715-.44-.655 0-1.149.132-1.481.398-.332.266-.499.578-.499.936 0 .33.152.592.455.785.303.192.65.288 1.04.288zm7.437 1.156c-.801 0-1.463-.183-1.986-.55a3.298 3.298 0 01-1.151-1.376l1.202-.468c.381.844 1.031 1.266 1.95 1.266.42 0 .765-.087 1.034-.261.268-.175.403-.404.403-.688 0-.44-.328-.739-.983-.895l-1.451-.33a3.545 3.545 0 01-1.305-.626c-.41-.308-.616-.723-.616-1.246 0-.596.281-1.08.843-1.452.562-.371 1.23-.557 2.002-.557.635 0 1.202.135 1.7.406.499.27.856.658 1.07 1.163l-1.172.454c-.264-.596-.811-.894-1.642-.894-.401 0-.738.078-1.012.234-.274.155-.41.366-.41.633 0 .385.317.646.953.784l1.422.316c.674.147 1.173.4 1.495.757.323.358.484.762.484 1.211 0 .606-.264 1.11-.792 1.514-.528.404-1.207.605-2.038.605zm6.866-.11c-.753 0-1.327-.188-1.723-.564-.396-.376-.594-.908-.594-1.596v-3.537h-1.26V12.06h1.26V9.995h1.35v2.064h1.759v1.156h-1.76v3.44c0 .734.323 1.101.968 1.101.244 0 .45-.036.616-.11l.469 1.087c-.293.12-.655.18-1.085.18zm4.725.11c-.801 0-1.464-.183-1.987-.55a3.298 3.298 0 01-1.15-1.376l1.202-.468c.381.844 1.031 1.266 1.95 1.266.42 0 .765-.087 1.033-.261.27-.175.404-.404.404-.688 0-.44-.328-.739-.983-.895l-1.451-.33a3.545 3.545 0 01-1.305-.626c-.41-.308-.616-.723-.616-1.246 0-.596.281-1.08.843-1.452.562-.371 1.23-.557 2.001-.557.636 0 1.203.135 1.701.406.499.27.855.658 1.07 1.163l-1.172.454c-.264-.596-.812-.894-1.643-.894-.4 0-.737.078-1.011.234-.274.155-.41.366-.41.633 0 .385.317.646.952.784l1.422.316c.675.147 1.173.4 1.496.757.322.358.484.762.484 1.211 0 .606-.264 1.11-.792 1.514-.528.404-1.207.605-2.038.605z",
    fill: "#6A6C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.59 13.666c0-2.946 2.494-5.333 5.47-5.333 1.641 0 2.81.64 3.693 1.473l-1.046 1.026a3.732 3.732 0 00-2.648-1.046c-2.165 0-3.858 1.727-3.858 3.87 0 2.144 1.693 3.87 3.858 3.87 1.406 0 2.206-.558 2.72-1.066.42-.417.697-1.016.8-1.829h-3.52V13.18h4.956c.051.264.082.569.082.914 0 1.097-.297 2.448-1.272 3.403-.954.975-2.165 1.493-3.766 1.493-2.975 0-5.468-2.387-5.468-5.323zm14.458-1.473c1.918 0 3.478 1.443 3.478 3.434 0 1.98-1.56 3.433-3.478 3.433-1.92 0-3.479-1.452-3.479-3.433 0-1.991 1.56-3.434 3.479-3.434zm0 5.506c1.046 0 1.96-.853 1.96-2.082 0-1.24-.914-2.083-1.96-2.083-1.057 0-1.96.843-1.96 2.083 0 1.229.913 2.082 1.96 2.082zm7.592-5.506c1.919 0 3.479 1.443 3.479 3.434 0 1.98-1.56 3.433-3.479 3.433-1.918 0-3.478-1.452-3.478-3.433 0-1.991 1.56-3.434 3.478-3.434zm0 5.506c1.047 0 1.96-.853 1.96-2.082 0-1.24-.903-2.083-1.96-2.083s-1.96.843-1.96 2.083c0 1.229.914 2.082 1.96 2.082zm9.317-5.394h1.457v6.166c0 2.54-1.509 3.576-3.294 3.576-1.683 0-2.698-1.118-3.078-2.032l1.324-.548c.236.558.81 1.219 1.744 1.219 1.139 0 1.847-.701 1.847-2.012v-.497h-.052c-.338.416-.995.782-1.826.782-1.734 0-3.324-1.504-3.324-3.424 0-1.94 1.59-3.443 3.324-3.443.831 0 1.488.365 1.826.772h.052v-.559zm-1.744 5.303c1.036 0 1.857-.864 1.846-2.073 0-1.208-.81-2.092-1.846-2.092-1.047 0-1.93.884-1.93 2.092 0 1.2.883 2.073 1.93 2.073zm4.237 1.219V8.74h1.519v10.087h-1.519zm5.695-1.128c.78 0 1.313-.376 1.713-.945l1.18.783c-.39.558-1.303 1.523-2.893 1.523-1.97 0-3.438-1.513-3.438-3.433 0-2.042 1.488-3.434 3.273-3.434 1.796 0 2.678 1.412 2.966 2.184l.154.386-4.638 1.9c.359.68.903 1.036 1.683 1.036zm-.113-4.185c-.78 0-1.857.68-1.816 2.001l3.098-1.27c-.164-.436-.677-.731-1.282-.731z",
    fill: "#65696D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePodcasts);
export default __webpack_public_path__ + "static/media/google-podcasts.e91a57f8f2ae7555677a6fc24a2272c7.svg";
export { ForwardRef as ReactComponent };